export default __webpack_public_path__ + "static/favicon-80a86ab14cbb773384dc83c570fb529d.png";